import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "mail_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22 19V7.5l-10 6-10-6V19h20Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 5h20l-10 6L2 5Z"
    }, null, -1)
  ]))]))
}
export default { render: render }